import { useModal } from "@ebay/nice-modal-react";
import { useEffect, useRef } from "react";

type ModalProps = {
  isOpen?: boolean;
  onClose?: () => void;
  onOpenChange?: (isOpen: boolean) => void;
};

export function useNiceModal(props?: ModalProps) {
  const { visible, show, hide, remove } = useModal();

  // a hidden NiceModal stays mounted and the next show() reuses its state, so
  // it would reopen with the previous payload's form values. unmount on hide.
  // visible is also false before the first show, hence the ref
  const wasVisible = useRef(false);
  useEffect(() => {
    if (visible) {
      wasVisible.current = true;
    } else if (wasVisible.current) {
      remove();
    }
  }, [visible, remove]);

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen) {
      void show();
    } else {
      void hide();
    }

    props?.onOpenChange?.(isOpen);
  };

  const handleClose = () => {
    remove();
    props?.onClose?.();
  };

  return {
    isOpen: visible,
    onOpenChange: handleOpenChange,
    onClose: handleClose,
    show,
    hide,
    remove,
  };
}
